(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umbilical-kimura-lp"]) return;
  try {
    
(function(){
function initializeKimuraLP(){
var root=document.getElementById('umbilical-kimura-root');if(!root)return;
if(window.__umbilicalKimuraCleanup)window.__umbilicalKimuraCleanup();
var cleanups=[];window.__umbilicalKimuraCleanup=function(){cleanups.splice(0).forEach(function(fn){fn();});};
function on(target,event,fn,options){target.addEventListener(event,fn,options);cleanups.push(function(){target.removeEventListener(event,fn,options);});}

  "use strict";
  var $ = function(s,c){return (c||root).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s));};

  
  var IMG = {
    lotion: $('#img-lotion').getAttribute('src'),
    serum:  $('#img-serum').getAttribute('src'),
    cream:  $('#img-cream').getAttribute('src')
  };
  $$('img[data-img]').forEach(function(el){ el.src = IMG[el.getAttribute('data-img')]; });
  var LABEL = {lotion:'化粧水', serum:'導入美容液', cream:'オールインワンクリーム'};

  
  var COURSES = [
    {id:'lotion', group:'single', grp:'SINGLE CARE', name:'化粧水 定期コース', short:'化粧水', items:['lotion'],
     lead:'毎日の保湿ケアから始めたい方に', care:'化粧水でうるおいを与える、毎日の保湿ケア', style:'いつものケアを、まず化粧水から見直したい',
     regular:12800, first:6400, firstOff:'通常価格の50%OFF', next:8980, nextOff:'通常価格の約30%OFF',
     href:'https://umbilical-beauty.com/products/umbilical-premium-aging-care-essence-lotion'},
    {id:'serum', group:'single', grp:'SINGLE CARE', name:'導入美容液 定期コース', short:'美容液', items:['serum'],
     lead:'UMBILICALを象徴するケアから始めたい方に', care:'洗顔後すぐに使う、導入美容液のケア', style:'今のスキンケアに、1本プラスしたい',
     regular:19800, first:9900, firstOff:'通常価格の50%OFF', next:12870, nextOff:'通常価格の35%OFF',
     href:'https://umbilical-beauty.com/products/umbilical-premium-aging-care-serum'},
    {id:'cream', group:'single', grp:'SINGLE CARE', name:'オールインワンクリーム 定期コース', short:'クリーム', items:['cream'],
     lead:'シンプルに保湿まで取り入れたい方に', care:'オールインワンクリームで、保湿まで', style:'ステップを少なく、シンプルに続けたい',
     regular:13800, first:6900, firstOff:'通常価格の50%OFF', next:8800, nextOff:'通常価格の36%OFF',
     href:'https://umbilical-beauty.com/products/umbilical-premium-aging-all-in-one-care-cream'},
    {id:'set2', group:'set', grp:'SET CARE', name:'導入美容液＋オールインワンクリーム 定期コース', short:'美容液＋クリーム', items:['serum','cream'],
     lead:'導入美容液から仕上げの保湿まで、<br>シンプルに取り入れたい方に。', care:'導入美容液と、仕上げのクリーム', style:'導入ケアと保湿の仕上げを、2つで両立したい',
     regular:26840, sum:33600, first:11800, firstOff:'単品合計価格の64.9%OFF', next:17380, nextOff:'単品合計価格の48%OFF',
     href:'https://umbilical-beauty.com/products/umbilical-premium-aging-care-set'},
    {id:'set3', group:'full', grp:'FULL LINE CARE', name:'化粧水＋導入美容液＋オールインワンクリーム 定期コース', short:'3点セット', items:['lotion','serum','cream'],
     lead:'UMBILICALのライン使いで、<br>毎日のスキンケアを整えたい方に。', care:'導入美容液・化粧水・クリームで、毎日のケアを', style:'シリーズをそろえて、毎日のケアをまるごと',
     regular:37180, sum:46400, first:16200, firstOff:'単品合計価格の65.1%OFF', next:24420, nextOff:'単品合計価格の47%OFF',
     href:'https://umbilical-beauty.com/products/serum-cream-lotion-set'}
  ];
  var config = JSON.parse(document.getElementById('km-shopify-config').textContent);
  var busy = false, uncertain = false;
  var subscriptionForm = $('#km-subscription-form');
  var onceForm = $('#km-one-time-form');
  var cycleSelect = $('#km-delivery-cycle');
  var courseSelect = $('#km-course-select');
  var status = $('#km-status');
  var cartCheck = $('#km-cart-check');
  var num = function(v){ return Number(v); };
  COURSES.forEach(function(c){
    var stock = config.stock[c.id];
    c.variantId = String(stock && stock.id || '');
    c.oneTimeAvailable = !!(stock && stock.available && !stock.requiresSellingPlan && config.currency === 'JPY' && num(stock.price) === c.regular * 100);
    c.plans = (config.approvedPlans[c.id] || []).filter(function(p){
      var allocation = stock && stock.plans.find(function(a){return String(a.id) === String(p.id);});
      if(!allocation) return false;
      var prices = allocation.prices.length ? allocation.prices : [allocation.price];
      return num(prices[0]) === c.first * 100 && num(prices[prices.length-1]) === c.next * 100;
    });
    c.subscriptionAvailable = !!(stock && stock.available && config.currency === 'JPY' && c.plans.length && num(stock.price) === c.regular * 100);
  });

  function purchaseSummary(resetCycle){
    var c = byId[current]; if(!c) return;
    var old = resetCycle ? '' : cycleSelect.value;
    cycleSelect.replaceChildren();
    var placeholder = document.createElement('option');
    placeholder.value = ''; placeholder.textContent = 'お届け周期を選択'; placeholder.disabled = true;
    cycleSelect.appendChild(placeholder);
    c.plans.forEach(function(p){
      var option = document.createElement('option'); option.value = p.id; option.textContent = p.label;
      cycleSelect.appendChild(option);
    });
    cycleSelect.value = c.plans.some(function(p){return p.id === old;}) ? old : '';
    cycleSelect.disabled = busy || uncertain || !c.subscriptionAvailable;
    courseSelect.value = c.id;
    courseSelect.disabled = busy || uncertain;
    $('#km-course-name').textContent = c.name;
    $('#km-contents').textContent = c.items.map(function(k){return LABEL[k]+' '+({lotion:'120mL',serum:'20mL',cream:'20g'})[k]+' ×1';}).join(' ／ ');
    $('#km-first-price').textContent = yen(c.first);
    $('#km-next-price').textContent = yen(c.next);
    $('#km-one-time-name').textContent = c.name.replace(' 定期コース','');
    $('#km-one-time-price').textContent = yen(c.regular);
    [subscriptionForm,onceForm].forEach(function(form){form.querySelector('[name="id"]').value = c.variantId;});
    subscriptionForm.querySelector('button[type="submit"]').disabled = busy || uncertain || !c.subscriptionAvailable;
    onceForm.querySelector('button[type="submit"]').disabled = busy || uncertain || !c.oneTimeAvailable;
    $$('.ccard').forEach(function(el){el.disabled=busy||uncertain;});
    var selected = c.plans.find(function(p){return p.id === cycleSelect.value;});
    $('#km-terms').textContent = (selected ? selected.label+'に、' : '選択した周期で、') + c.short+'を各1点お届けします。初回'+yen(c.first)+'円、2回目以降は1回あたり'+yen(c.next)+'円（税込）。解約まで継続します。';
    var unavailable = $('#km-availability');
    unavailable.hidden = c.subscriptionAvailable;
    unavailable.textContent = c.subscriptionAvailable ? '' : '現在、この定期コースはお申し込みいただけません。商品・定期プランの設定を確認中です。';
  }

  function lockPurchase(locked){
    busy = locked;
    [subscriptionForm,onceForm].forEach(function(form){
      var button = form.querySelector('button[type="submit"]');
      button.setAttribute('aria-busy',locked?'true':'false');
    });
    purchaseSummary(false);
  }

  async function addToCart(event){
    event.preventDefault();
    if(busy || uncertain) return;
    var form = event.currentTarget;
    var c = byId[current];
    var isSubscription = form === subscriptionForm;
    if(!c || !(isSubscription ? c.subscriptionAvailable : c.oneTimeAvailable)) return;
    if(!form.reportValidity()) return;
    var plan = isSubscription ? c.plans.find(function(p){return p.id === cycleSelect.value;}) : null;
    if(isSubscription && !plan){ cycleSelect.focus(); return; }
    var item = {id:c.variantId,quantity:1};
    if(plan) item.selling_plan = plan.id;
    status.textContent = 'カートに追加しています…'; cartCheck.hidden = true;
    lockPurchase(true);
    var controller = new AbortController();
    var timer = window.setTimeout(function(){controller.abort();},20000);
    try {
      var response = await fetch(config.cartAddUrl + '.js',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[item]}),signal:controller.signal
      });
      var result = await response.json();
      if(!response.ok){
        if(response.status>=500) throw new Error('uncertain');
        status.textContent = typeof result.description === 'string' ? result.description : 'カートに追加できませんでした。商品・周期を確認して、もう一度お試しください。';
        lockPurchase(false); return;
      }
      var added = result.items && result.items[0];
      if(!added || String(added.variant_id || added.id) !== c.variantId || (plan && String(added.selling_plan_allocation && added.selling_plan_allocation.selling_plan.id) !== plan.id)) throw new Error('uncertain');
      status.textContent = 'カートに追加しました。カートへ移動します。';
      window.location.assign(config.cartUrl);
    } catch(error){
      uncertain = true;
      status.textContent = '通信結果を確認できませんでした。重複追加を避けるため、先にカートの内容をご確認ください。';
      cartCheck.hidden = false;
      lockPurchase(false);
    } finally {window.clearTimeout(timer);}
  }

  on(subscriptionForm,'submit',addToCart);
  on(onceForm,'submit',addToCart);
  on(cycleSelect,'change',function(){purchaseSummary(false);status.textContent='';});
  on(courseSelect,'change',function(){select(courseSelect.value,{user:true});});
  on(root,'keydown',function(e){
    var card = e.target.closest('.ccard');
    if(!card || busy || uncertain || !['ArrowDown','ArrowUp','ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
    e.preventDefault(); var cards = $$('.ccard'), at=cards.indexOf(card);
    var index = e.key==='Home'?0:e.key==='End'?cards.length-1:(at+(['ArrowDown','ArrowRight'].includes(e.key)?1:-1)+cards.length)%cards.length;
    select(cards[index].dataset.course,{user:true});cards[index].focus();
  });
  on(window,'pageshow',function(e){if(e.persisted){busy=false;uncertain=false;cartCheck.hidden=true;status.textContent='';purchaseSummary(false);}});

  var byId = {}; COURSES.forEach(function(c){ byId[c.id]=c; });
  var yen = function(n){ return n.toLocaleString('ja-JP'); };
  var imgs = function(c){ return c.items.map(function(k){ return '<img class="m-'+k+'" src="'+IMG[k]+'" alt="">'; }).join(''); };

  
  COURSES.forEach(function(c){
    var wrap = $('.cg-cards[data-group="'+c.group+'"]');
    var b = document.createElement('button');
    var recommended=c.id==='set2'||c.id==='set3';
    b.type='button'; b.className='ccard'+(recommended?' ccard-recommended':''); b.setAttribute('role','radio'); b.setAttribute('aria-checked','false'); b.dataset.course=c.id;
    b.innerHTML =
      (recommended?'<span class="km-recommend-badge">おすすめ · '+(c.id==='set3'?'3点セット':'2点セット')+'</span>':'')+
      '<span class="radio" aria-hidden="true"></span>'+
      '<span class="c-img">'+imgs(c)+'</span>'+
      '<span class="c-body">'+
        '<span class="c-name" style="display:block">'+c.name+'</span>'+
        '<span class="c-lead" style="display:block">'+c.lead+'</span>'+
        '<span class="c-price" style="display:block">初回<b>'+yen(c.first)+'</b><span class="tax">円（税込）</span><span class="off">'+c.firstOff.replace('単品合計価格の','単品合計価格より ').replace('通常価格の','通常価格より ')+'</span></span>'+
      '</span>';
    wrap.appendChild(b);
    var courseOption=document.createElement('option');
    courseOption.value=c.id;courseOption.textContent=(recommended?'【おすすめ】':'')+(c.id==='set3'?'化粧水＋美容液＋クリーム':c.short)+' 定期';
    courseSelect.appendChild(courseOption);
  });

  
  var current = null;
  function select(id, opts){
    var c = byId[id]; if(!c || busy || uncertain) return; var changed=current!==id; current = id;
    $$('.ccard').forEach(function(el){ el.setAttribute('aria-checked', el.dataset.course===id ? 'true':'false'); el.tabIndex=el.dataset.course===id?0:-1; });
    $('#sb-name').textContent = c.name;
    $('#sb-first').textContent = yen(c.first);
    $('#sb-btn').href = '#km-purchase'; purchaseSummary(changed); if(changed){status.textContent='';cartCheck.hidden=true;}
    if(opts && opts.user){ try{ history.replaceState(null,'','#course-'+id); }catch(e){} }
    if(opts && opts.scroll){
      var step=$('#km-delivery-step');step.focus({preventScroll:true});scrollToEl(step);
    }
  }
  on(root,'click', function(e){
    var t = e.target.closest('[data-course]');
    if(!t) return;
    select(t.dataset.course, {scroll: true, user:true});
  });
  var initial = (location.hash.match(/^#course-(\w+)/)||[])[1];
  select(byId[initial] ? initial : 'set3');

  
  function scrollToEl(el){
    if(!el) return;
    var h = $('.header').offsetHeight;
    var y = el.getBoundingClientRect().top + window.pageYOffset - h + 1;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top:y, behavior: reduce ? 'auto' : 'smooth'});
  }
  $$('a[href^="#"]').forEach(function(a){
    on(a,'click', function(e){
      var id = a.getAttribute('href');
      if(id.length<2) return;
      var el = document.getElementById(id.slice(1));
      if(!el) return;
      e.preventDefault(); scrollToEl(el);
    });
  });


  
  $$('.uv-card, .ex-card').forEach(function(card){
    on(card,'mouseenter',function(){ Array.prototype.forEach.call(card.parentNode.children,function(c){ c.classList.toggle('is-active', c===card); }); });
  });
  $$('.prd-more').forEach(function(btn){
    var panel=document.getElementById(btn.getAttribute('aria-controls')), label=$('.prd-more-t',btn);
    on(btn,'click',function(){ var open=panel.getAttribute('data-open')!=='true';
      panel.setAttribute('data-open',open?'true':'false'); btn.setAttribute('aria-expanded',open?'true':'false');
      label.textContent=open?'閉じる':'詳しく見る'; });
  });
  $$('.q2').forEach(function(box){
    var btn=$('.q2-toggle',box), label=$('.q2-toggle-t',box);
    on(btn,'click',function(){ var open=box.getAttribute('data-open')!=='true';
      box.setAttribute('data-open',open?'true':'false'); btn.setAttribute('aria-expanded',open?'true':'false');
      label.textContent=open?'閉じる':'詳しく見る'; });
  });
  $$('.qa').forEach(function(box){
    var btn = $('.qa-toggle', box), label = $('.qa-toggle-t', box);
    on(btn,'click', function(){
      var open = box.getAttribute('data-open') !== 'true';
      box.setAttribute('data-open', open ? 'true' : 'false');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = open ? '閉じる' : '詳しく見る';
    });
  });
  
  var fades = $$('.fade, .why-panel, .cv');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    fades.forEach(function(el){ io.observe(el); }); cleanups.push(function(){io.disconnect();});
  } else { fades.forEach(function(el){ el.classList.add('is-in'); }); }

  
  var bar = $('#sp-bar');
  var zoneStart = $('#course'), zoneEnd = $('#course');
  function onScroll(){
    var vh = window.innerHeight;
    var s = zoneStart.getBoundingClientRect(), en = zoneEnd.getBoundingClientRect();
    var inZone = s.top < vh*0.4 && en.bottom > vh*0.6;
    var show = inZone;
    bar.classList.toggle('show', show);
    bar.setAttribute('aria-hidden', show ? 'false':'true');
  }
  on(window,'scroll', onScroll, {passive:true});
  on(window,'resize', onScroll);
  onScroll();


}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeKimuraLP,{once:true});else initializeKimuraLP();
document.addEventListener('shopify:section:load',function(event){if(event.target.querySelector('#umbilical-kimura-root'))initializeKimuraLP();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umbilical-main-lp"]) return;
  try {
    
(()=>{
function initializeUmbilicalLP(){
  const root=document.getElementById('umbilical-lp-root');if(!root)return;
  window.__umbilicalLPCleanup?.();
  const config=JSON.parse(root.querySelector('[data-lp-config]').textContent);
  const cleanup=[];window.__umbilicalLPCleanup=()=>cleanup.splice(0).forEach(fn=>fn());
  const on=(target,event,callback,options)=>{target.addEventListener(event,callback,options);cleanup.push(()=>target.removeEventListener(event,callback,options));};
  const tr=(key,values=[])=>String(config.copy[key]??'').replace(/__UMB_V([0-9]+)__/g,(_,i)=>String(values[Number(i)]??'')).replaceAll('__UMB_CTA__',config.ctaLabel);






const courses=[
  {
    "id": "lotion",
    "name": tr('copy_001'),
    "items": tr('copy_002'),
    "group": "single",
    "regular": 12800,
    "initial": 6400,
    "recurring": 8980,
    "image": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-lotion-marble-20260916.webp?v=1789524613",
    "alt": tr('copy_002'),
    "sourceRow": 4,
    "deliveryInterval": tr('copy_003'),
    "deliveryQuantity": tr('copy_004'),
    "variantId": "41199266758699",
    "productUrl": "https://umbilical-beauty.com/products/umbilical-premium-aging-care-essence-lotion",
    "deliveryOptions": [
      {
        "id": "1752498219",
        "label": tr('copy_005'),
        "interval": "WEEK",
        "intervalCount": 3
      },
      {
        "id": "1752530987",
        "label": tr('copy_006'),
        "interval": "MONTH",
        "intervalCount": 1
      },
      {
        "id": "1752465451",
        "label": tr('copy_007'),
        "interval": "MONTH",
        "intervalCount": 2
      },
      {
        "id": "6670975019",
        "label": tr('copy_008'),
        "interval": "MONTH",
        "intervalCount": 3
      }
    ],
    "imageSrcset": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-lotion-marble-20260916.webp?v=1789524613&width=320 320w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-lotion-marble-20260916.webp?v=1789524613&width=640 640w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-lotion-marble-20260916.webp?v=1789524613&width=960 960w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-lotion-marble-20260916.webp?v=1789524613&width=1254 1254w"
  },
  {
    "id": "serum",
    "name": tr('copy_009'),
    "items": tr('copy_010'),
    "group": "single",
    "regular": 19800,
    "initial": 9900,
    "recurring": 12870,
    "image": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-serum-marble-20260916.webp?v=1789524627",
    "alt": tr('copy_010'),
    "sourceRow": 3,
    "deliveryInterval": tr('copy_003'),
    "deliveryQuantity": tr('copy_004'),
    "variantId": "40343121428523",
    "productUrl": "https://umbilical-beauty.com/products/umbilical-premium-aging-care-serum",
    "deliveryOptions": [
      {
        "id": "1074200619",
        "label": tr('copy_005'),
        "interval": "WEEK",
        "intervalCount": 3
      },
      {
        "id": "1074233387",
        "label": tr('copy_006'),
        "interval": "MONTH",
        "intervalCount": 1
      },
      {
        "id": "1074167851",
        "label": tr('copy_011'),
        "interval": "WEEK",
        "intervalCount": 6
      },
      {
        "id": "1074266155",
        "label": tr('copy_007'),
        "interval": "MONTH",
        "intervalCount": 2
      }
    ],
    "imageSrcset": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-serum-marble-20260916.webp?v=1789524627&width=320 320w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-serum-marble-20260916.webp?v=1789524627&width=640 640w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-serum-marble-20260916.webp?v=1789524627&width=960 960w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-serum-marble-20260916.webp?v=1789524627&width=1254 1254w"
  },
  {
    "id": "cream",
    "name": tr('copy_012'),
    "items": tr('copy_013'),
    "group": "single",
    "regular": 13800,
    "initial": 6900,
    "recurring": 8800,
    "image": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-cream-marble-20260916.webp?v=1789524644",
    "alt": tr('copy_013'),
    "sourceRow": 5,
    "deliveryInterval": tr('copy_003'),
    "deliveryQuantity": tr('copy_014'),
    "variantId": "40696141807659",
    "productUrl": "https://umbilical-beauty.com/products/umbilical-premium-aging-all-in-one-care-cream",
    "deliveryOptions": [
      {
        "id": "1071972395",
        "label": tr('copy_005'),
        "interval": "WEEK",
        "intervalCount": 3
      },
      {
        "id": "1072005163",
        "label": tr('copy_006'),
        "interval": "MONTH",
        "intervalCount": 1
      },
      {
        "id": "1071939627",
        "label": tr('copy_011'),
        "interval": "WEEK",
        "intervalCount": 6
      },
      {
        "id": "1072037931",
        "label": tr('copy_007'),
        "interval": "MONTH",
        "intervalCount": 2
      }
    ],
    "imageSrcset": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-cream-marble-20260916.webp?v=1789524644&width=320 320w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-cream-marble-20260916.webp?v=1789524644&width=640 640w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-cream-marble-20260916.webp?v=1789524644&width=960 960w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-cream-marble-20260916.webp?v=1789524644&width=1254 1254w"
  },
  {
    "id": "duo",
    "name": tr('copy_015'),
    "items": tr('copy_016'),
    "group": "set",
    "regular": 26840,
    "initial": 11800,
    "recurring": 17380,
    "image": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-duo-marble-20260916.webp?v=1789524510",
    "alt": tr('copy_017'),
    "sourceRow": 6,
    "deliveryInterval": tr('copy_003'),
    "deliveryQuantity": tr('copy_018'),
    "variantId": "40696142200875",
    "productUrl": "https://umbilical-beauty.com/products/umbilical-premium-aging-care-set",
    "deliveryOptions": [
      {
        "id": "1072103467",
        "label": tr('copy_005'),
        "interval": "WEEK",
        "intervalCount": 3
      },
      {
        "id": "1072136235",
        "label": tr('copy_006'),
        "interval": "MONTH",
        "intervalCount": 1
      },
      {
        "id": "1072070699",
        "label": tr('copy_011'),
        "interval": "WEEK",
        "intervalCount": 6
      },
      {
        "id": "1072169003",
        "label": tr('copy_007'),
        "interval": "MONTH",
        "intervalCount": 2
      }
    ],
    "imageSrcset": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-duo-marble-20260916.webp?v=1789524510&width=320 320w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-duo-marble-20260916.webp?v=1789524510&width=640 640w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-duo-marble-20260916.webp?v=1789524510&width=960 960w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-duo-marble-20260916.webp?v=1789524510&width=1254 1254w"
  },
  {
    "id": "trio",
    "name": tr('copy_019'),
    "items": tr('copy_020'),
    "group": "set",
    "regular": 37180,
    "initial": 16200,
    "recurring": 24420,
    "image": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-trio-marble-20260916.webp?v=1789524495",
    "alt": tr('copy_021'),
    "sourceRow": 7,
    "deliveryInterval": tr('copy_003'),
    "deliveryQuantity": tr('copy_022'),
    "variantId": "41449603629099",
    "productUrl": "https://umbilical-beauty.com/products/serum-cream-lotion-set",
    "deliveryOptions": [
      {
        "id": "7893483563",
        "label": tr('copy_005'),
        "interval": "WEEK",
        "intervalCount": 3
      },
      {
        "id": "7893516331",
        "label": tr('copy_006'),
        "interval": "MONTH",
        "intervalCount": 1
      },
      {
        "id": "7893450795",
        "label": tr('copy_011'),
        "interval": "WEEK",
        "intervalCount": 6
      },
      {
        "id": "7893549099",
        "label": tr('copy_007'),
        "interval": "MONTH",
        "intervalCount": 2
      },
      {
        "id": "9839673387",
        "label": tr('copy_023'),
        "interval": "MONTH",
        "intervalCount": 4
      }
    ],
    "imageSrcset": "https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-trio-marble-20260916.webp?v=1789524495&width=320 320w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-trio-marble-20260916.webp?v=1789524495&width=640 640w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-trio-marble-20260916.webp?v=1789524495&width=960 960w, https://cdn.shopify.com/s/files/1/0578/3758/4427/files/umbilical-lp-trio-marble-20260916.webp?v=1789524495&width=1254 1254w"
  }
];
const defaultCourseId = 'trio';
const formatYen = value => new Intl.NumberFormat('ja-JP').format(value);


function oneTimeCartLink(id) {
  const variantId=findCourse(id).variantId;
  if(!variantId||!/^\d+$/.test(variantId))throw new TypeError('Invalid product variant');
  return `https://umbilical-beauty.com/cart/${variantId}:1?storefront=true`;
}
function findDeliveryOption(courseId,planId) {
  const option=findCourse(courseId).deliveryOptions.find(item=>item.id===planId);
  if(!option)throw new RangeError('Select a delivery cycle for this product');
  return option;
}
function subscriptionCartLink(courseId,planId) {
  const course=findCourse(courseId);
  const option=findDeliveryOption(courseId,planId);
  const url=new URL('https://umbilical-beauty.com/apps/subscription/buy');
  url.search=new URLSearchParams({id:course.variantId,selling_plan:option.id,quantity:'1',is_cart:'1'}).toString();
  return url.href;
}
function findCourse(id) {
  const course=courses.find(item=>item.id===id);
  if(!course) throw new RangeError('Unknown course');
  return course;
}
function priceSummary(id) {
  const course=findCourse(id);
  return {id:course.id,name:course.name,items:course.items,currency:'JPY',taxIncluded:true,regular:course.regular,initial:course.initial,recurring:course.recurring,saving:course.regular-course.initial,deliveryInterval:course.deliveryInterval,deliveryQuantity:course.deliveryQuantity,deliveryOptions:course.deliveryOptions,cycleSelectionRequired:true,cartAvailable:true};
}


function valueSummary(id) {
  const course=findCourse(id);
  const memberIds=id==='trio'?['lotion','serum','cream']:id==='duo'?['serum','cream']:[id];
  const members=memberIds.map(findCourse);
  const individualRegularTotal=members.reduce((sum,item)=>sum+item.regular,0);
  const separateInitialTotal=members.reduce((sum,item)=>sum+item.initial,0);
  return {
    memberIds,individualRegularTotal,separateInitialTotal,
    initialDiscount:Math.floor((individualRegularTotal-course.initial)*100/individualRegularTotal),
    initialSaving:individualRegularTotal-course.initial,
    recurringSaving:individualRegularTotal-course.recurring,
    savingVsSeparateInitial:separateInitialTotal-course.initial,
    ownRegularDiscount:Math.floor((course.regular-course.initial)*100/course.regular)
  };
}



for(const course of courses){
  const actual=config.stock[course.id];
  course.oneTimeAvailable=Boolean(actual&&String(actual.id)===course.variantId&&actual.available&&!actual.requiresSellingPlan&&Number(actual.price)===course.regular*100&&config.currency==='JPY');
  const allocations=new Map((actual?.plans||[]).map(p=>[String(p.id),p]));
  course.deliveryOptions=course.deliveryOptions.filter(option=>{
    const plan=allocations.get(option.id);
    if(!plan)return false;
    const prices=plan.prices.length?plan.prices:[plan.price];
    return Number(prices[0])===course.initial*100&&Number(prices.at(-1))===course.recurring*100;
  });
  course.subscriptionAvailable=Boolean(actual&&String(actual.id)===course.variantId&&actual.available&&config.currency==='JPY'&&course.deliveryOptions.length);
}
function refreshAvailability(){
  root.querySelectorAll('[data-subscription-form],[data-one-time-form]').forEach(form=>{
    const subscription=Boolean(form.dataset.subscriptionForm);
    const course=findCourse(form.dataset.subscriptionForm||form.dataset.oneTimeForm);
    const enabled=subscription?course.subscriptionAvailable:course.oneTimeAvailable;
    form.querySelectorAll('button[type="submit"]').forEach(button=>button.disabled=!enabled);
    const select=form.querySelector('select[name="selling_plan"]');if(select)select.disabled=!enabled;
    let note=form.querySelector('.lp-availability-note');
    if(!enabled&&!note){
      note=document.createElement('p');note.className='lp-availability-note';note.setAttribute('role','status');
      note.append(document.createTextNode(tr('copy_024')));
      const link=document.createElement('a');link.href=course.productUrl;link.textContent=tr('copy_025');note.append(link);form.append(note);
    }
    if(enabled&&note)note.remove();
  });
}
function guardSubmission(event){
  const form=event.target;if(!form.matches('[data-subscription-form],[data-one-time-form]'))return;
  if(event.defaultPrevented)return;
  const id=form.dataset.subscriptionForm||form.dataset.oneTimeForm;const course=findCourse(id);
  const subscription=Boolean(form.dataset.subscriptionForm);
  if(form.dataset.submitting==='true'||!(subscription?course.subscriptionAvailable:course.oneTimeAvailable)){event.preventDefault();return;}
  if(subscription){try{findDeliveryOption(id,form.querySelector('[name="selling_plan"]').value);}catch{event.preventDefault();return;}}
  form.querySelector('[name="id"]').value=course.variantId;
  form.dataset.submitting='true';
  const button=form.querySelector('button[type="submit"]');button.setAttribute('aria-busy','true');
  if(!window.navigator.globalPrivacyControl&&window.navigator.doNotTrack!=='1'&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()){
    window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'lp_cart_click',lp_version:'shopify_20260916',course_id:id,purchase_type:subscription?'subscription':'one_time',selling_plan_id:subscription?form.querySelector('[name="selling_plan"]').value:undefined});
  }
}
on(root,'submit',guardSubmission);
on(window,'pageshow',()=>{root.querySelectorAll('[data-submitting]').forEach(form=>{delete form.dataset.submitting;form.querySelector('[aria-busy]')?.removeAttribute('aria-busy');});refreshAvailability();});


let selectedCourseId=defaultCourseId;
let selectedSetId=defaultCourseId;
let selectedNormalSetId=defaultCourseId;
const selectedPlanIds=Object.create(null);

function oneTimeMarkup(course){
  return `<details class="offer-one-time" id="one-time-${course.id}">
    <summary><span>${tr('copy_026',[])}</span><span class="expand" aria-hidden="true"></span></summary>
    <div class="offer-one-time-content">
      <p class="offer-one-time-label">${course.group==='set'?tr('copy_032'):tr('copy_033')}</p>
      <p class="offer-one-time-price"><strong>${formatYen(course.regular)}</strong>${tr('copy_027',[])}</p>
      <p>${tr('copy_028',[course.deliveryQuantity])}</p>
      <form class="one-time-cart-form" data-one-time-form="${course.id}" method="post" action="${config.cartAddUrl}"><input type="hidden" name="id" value="${course.variantId}"><input type="hidden" name="quantity" value="1"><input type="hidden" name="return_to" value="${config.cartUrl}"><button type="submit" class="offer-one-time-button" id="one-time-checkout-${course.id}" data-one-time-course="${course.id}" aria-label="${tr('copy_029',[course.name,formatYen(course.regular)])}">${tr('copy_030',[])}</button></form>
      <p class="offer-one-time-note">${tr('copy_031',[])}</p>
    </div>
  </details>`;
}

function cycleOptionsMarkup(course){
  return `<option value="" disabled>${tr('copy_034',[])}</option>`+course.deliveryOptions.map(option=>    `<option value="${option.id}">${option.label}</option>`).join('');
}

function subscriptionFormMarkup(course,isSet=false){
  const key=isSet?'set':course.id;
  return `<form class="subscription-cart-form" id="subscription-form-${key}" data-subscription-form="${course.id}" method="post" action="${config.cartAddUrl}">
    <input type="hidden" name="id" value="${course.variantId}">
    <input type="hidden" name="quantity" value="1">
    <input type="hidden" name="return_to" value="${config.cartUrl}">
    <div class="delivery-choice">
      <label for="delivery-cycle-${key}"><span>${tr('copy_035',[])}</span><span>${tr('copy_036',[])}</span></label>
      <select id="delivery-cycle-${key}" name="selling_plan" data-delivery-course="${course.id}" required aria-describedby="delivery-help-${key}">${cycleOptionsMarkup(course)}</select>
      <p id="delivery-help-${key}">${tr('copy_037',[])}</p>
    </div>
    <button type="submit" class="button ${isSet?'compact-checkout':'offer-checkout'}" id="${isSet?'set-checkout-button':'subscribe-'+course.id}" data-subscription-link="${course.id}" aria-describedby="${isSet?'set-subscription-note set-purchase-support':'offer-terms-'+course.id}" aria-label="${tr('copy_038',[course.name])}">${tr('copy_030',[])}<span aria-hidden="true">${tr('copy_039',[])}</span></button>
    <p class="cart-action-note">${tr('copy_040',[])}</p>
  </form>`;
}

function subscriptionButton(course){
  return `${subscriptionFormMarkup(course)}
    <p class="offer-terms" id="offer-terms-${course.id}">${tr('copy_041',[course.deliveryQuantity])}</p>
    <p class="purchase-support">${tr('copy_042',[])}<a class="subscription-guide" href="#subscription-terms">${tr('copy_043',[])}</a></p>`;
}

function itemPurchaseMarkup(course){
  const value=valueSummary(course.id);
  return `<div class="item-offer-heading"><span>${tr('copy_044',[])}</span><span class="item-discount">${tr('copy_045',[])} <strong>${value.initialDiscount}</strong>${tr('copy_046',[])}</span></div>
    <p class="item-regular">${tr('copy_033',[])} <s>${tr('copy_047',[formatYen(course.regular)])}</s>${tr('copy_048',[])}</p>
    <p class="item-initial"><span>${tr('copy_049',[])}</span><strong>${formatYen(course.initial)}</strong><span>${tr('copy_027',[])}</span></p>
    <p class="item-price-saving">${tr('copy_045',[])} <strong>${formatYen(value.initialSaving)}</strong><span>${tr('copy_050',[])}</span></p>
    <p class="item-recurring">${tr('copy_051',[])} <strong>${formatYen(course.recurring)}</strong>${tr('copy_027',[])}</p>
    <p class="item-recurring-saving">${tr('copy_052',[formatYen(value.recurringSaving)])}</p>
    <p class="item-delivery">${tr('copy_053',[course.deliveryQuantity])}</p>
    ${subscriptionButton(course)}${oneTimeMarkup(course)}`;
}

function setOptionMarkup(course){
  const value=valueSummary(course.id);
  const selected=course.id===selectedSetId;
  return `<label class="compact-set-option${selected?' is-selected':''}" id="course-${course.id}">
    <input type="radio" name="set-course" value="${course.id}" ${selected?'checked':''} aria-label="${tr('copy_054',[course.name,formatYen(value.individualRegularTotal),formatYen(course.initial),value.initialDiscount,formatYen(value.initialSaving),formatYen(course.recurring)])}">
    <span class="compact-choice-state" aria-hidden="true"><span class="compact-choice-check">${tr('copy_055',[])}</span><span data-option-state>${selected?tr('copy_068'):tr('copy_069')}</span></span>
    <img src="${course.image}" srcset="${course.imageSrcset}" sizes="(max-width: 600px) calc((100vw - 118px) / 2), (max-width: 840px) calc((100vw - 192px) / 2), 300px" alt="${tr('copy_056',[course.alt])}" width="1254" height="1254" loading="lazy" decoding="async">
    <span class="compact-option-name">${course.name}</span>
    <span class="compact-option-purpose">${course.id==='duo'?tr('copy_070'):tr('copy_071')}</span>
    <span class="compact-option-items">${course.items}<br>${tr('copy_057',[])}</span>
    <span class="compact-price-comparison">
      <span class="compact-discount-flag"><span>${tr('copy_045',[])}</span><span><strong>${value.initialDiscount}</strong>${tr('copy_058',[])}</span></span>
      <span class="compact-option-regular"><span>${tr('copy_059',[])}</span><s>${tr('copy_047',[formatYen(value.individualRegularTotal)])}</s></span>
      <span class="compact-option-price"><span>${tr('copy_049',[])}</span><strong>${tr('copy_060',[formatYen(course.initial)])}</strong></span>
      <span class="compact-option-tax">${tr('copy_061',[])}</span>
      <span class="compact-price-saving"><span>${tr('copy_062',[])}</span><strong>${formatYen(value.initialSaving)}<span>${tr('copy_063',[])}</span></strong></span>
    </span>
    <span class="compact-option-recurring">${tr('copy_051',[])} <strong>${tr('copy_047',[formatYen(course.recurring)])}</strong>${tr('copy_048',[])}<span class="compact-recurring-saving">${tr('copy_064',[formatYen(value.recurringSaving)])}</span>${tr('copy_065',[])}</span>
    <span class="compact-option-saving">${tr('copy_066',[])}<br>${tr('copy_067',[formatYen(value.savingVsSeparateInitial)])}</span>
  </label>`;
}

for(const element of document.querySelectorAll('[data-item-purchase]'))element.innerHTML=itemPurchaseMarkup(findCourse(element.dataset.itemPurchase));
document.getElementById('set-course-options').innerHTML=['duo','trio'].map(id=>setOptionMarkup(findCourse(id))).join('');
const setForm=document.getElementById('set-course-form');
document.getElementById('set-subscription-controls').innerHTML=subscriptionFormMarkup(findCourse(selectedSetId),true);

function updateSetPurchase(id){
  const course=findCourse(id);
  if(course.group!=='set')throw new RangeError('A set course is required');
  selectedSetId=id;
  setForm.querySelectorAll('input[name="set-course"]').forEach(input=>{
    input.checked=input.value===id;
    const option=input.closest('.compact-set-option');
    option.classList.toggle('is-selected',input.checked);
    option.querySelector('[data-option-state]').textContent=input.checked?tr('copy_068'):tr('copy_069');
  });
  const link=document.getElementById('set-checkout-button');
  const form=document.getElementById('subscription-form-set');
  const select=document.getElementById('delivery-cycle-set');
  if(form.dataset.subscriptionForm!==id || !select.options.length){
    select.innerHTML=cycleOptionsMarkup(course);
  }
  form.dataset.subscriptionForm=id;
  form.querySelector('input[name="id"]').value=course.variantId;
  select.dataset.deliveryCourse=id;
  select.value=selectedPlanIds[id]||'';
  link.textContent=tr('copy_030');
  link.setAttribute('data-subscription-link',id);
  link.setAttribute('aria-label',tr('copy_072',[course.name,formatYen(course.initial),formatYen(course.recurring)]));
  document.getElementById('set-subscription-note').textContent=tr('copy_073',[course.name,selectedPlanIds[id]?findDeliveryOption(id,selectedPlanIds[id]).label+tr('copy_074'):tr('copy_075'),formatYen(course.initial),formatYen(course.recurring)]);
}

function selectCourse(id,{scroll=false,announce=true,focus=false}={}){
  const course=findCourse(id);
  const value=valueSummary(id);
  selectedCourseId=course.id;
  if(course.group==='set')updateSetPurchase(id);
  document.querySelectorAll('[data-course-card]').forEach(card=>card.classList.toggle('is-selected',card.dataset.courseCard===id));
  document.getElementById('mobile-initial').textContent=formatYen(course.initial);
  document.getElementById('purchase-bar-course').textContent=course.name;
  document.getElementById('purchase-bar-discount').textContent=tr('copy_076',[value.initialDiscount]);
  document.getElementById('purchase-bar-comparison').textContent=tr('copy_077',[course.group==='set'?tr('copy_059'):tr('copy_033'),formatYen(value.individualRegularTotal)]);
  const purchaseBarLink=document.querySelector('.purchase-bar-button');
  purchaseBarLink.href=course.group==='set'?'#courses':'#course-'+id;
  purchaseBarLink.setAttribute('aria-label',tr('copy_078',[course.name]));
  if(announce)document.getElementById('selection-announcement').textContent=tr('copy_079',[course.name,formatYen(course.initial),formatYen(course.recurring),course.deliveryQuantity]);
  if(scroll)document.getElementById(course.group==='set'?'courses':'course-'+id).scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  if(focus){
    const target=course.group==='set'?setForm.querySelector(`input[value="${id}"]`):document.querySelector(`[data-subscription-link="${id}"]`);
    target.focus({preventScroll:true});
  }
  refreshAvailability();
  return priceSummary(id);
}

function selectNormalSet(id){
  const course=findCourse(id);
  if(course.group!=='set')throw new RangeError('A set course is required');
  selectedNormalSetId=id;
  document.getElementById('normal-set-select').value=id;
  document.getElementById('normal-set-price').textContent=formatYen(course.regular);
  document.getElementById('normal-set-quantity').textContent=tr('copy_080',[course.deliveryQuantity]);
  const link=document.getElementById('one-time-set-checkout');
  const normalForm=document.getElementById('one-time-form-set');
  normalForm.dataset.oneTimeForm=id;
  normalForm.querySelector('input[name="id"]').value=course.variantId;
  link.setAttribute('data-one-time-course',id);
  link.setAttribute('aria-label',tr('copy_029',[course.name,formatYen(course.regular)]));
  refreshAvailability();
}
setForm.addEventListener('change',event=>{if(event.target.matches('input[name="set-course"]'))selectCourse(event.target.value);});
setForm.addEventListener('submit',event=>event.preventDefault());
document.getElementById('normal-set-select').addEventListener('change',event=>selectNormalSet(event.target.value));
document.querySelectorAll('[data-select-course]').forEach(control=>control.addEventListener('click',event=>{event.preventDefault();selectCourse(control.dataset.selectCourse,{scroll:true,focus:true});}));
document.querySelectorAll('[data-delivery-course]').forEach(select=>{
  select.value=selectedPlanIds[select.dataset.deliveryCourse]||'';
  select.addEventListener('change',()=>{
    const id=select.dataset.deliveryCourse;
    const option=findDeliveryOption(id,select.value);
    selectedPlanIds[id]=option.id;
    selectCourse(id,{announce:false});
    if(findCourse(id).group==='single')document.getElementById('offer-terms-'+id).textContent=tr('copy_081',[option.label,findCourse(id).deliveryQuantity]);
    document.getElementById('selection-announcement').textContent=tr('copy_082',[findCourse(id).name,option.label]);
  });
});
document.querySelectorAll('[data-subscription-form]').forEach(form=>form.addEventListener('submit',event=>{
  const id=form.dataset.subscriptionForm;
  const select=form.querySelector('select[name="selling_plan"]');
  try{
    findDeliveryOption(id,select.value);
    if(!form.reportValidity()){event.preventDefault();return;}
    form.querySelector('input[name="id"]').value=findCourse(id).variantId;
  }catch{
    event.preventDefault();
    select.value='';
    select.focus();
    select.reportValidity();
  }
}));
document.querySelectorAll('[data-subscription-link]').forEach(link=>{
  link.addEventListener('focus',()=>selectCourse(link.dataset.subscriptionLink,{announce:false}));
  link.addEventListener('click',()=>selectCourse(link.dataset.subscriptionLink,{announce:false}));
});
document.querySelectorAll('.subscription-guide').forEach(link=>link.addEventListener('click',()=>{document.getElementById('subscription-terms').open=true;}));
selectCourse(selectedCourseId,{announce:false});
selectNormalSet(selectedNormalSetId);



const purchaseBar=document.getElementById('mobile-purchase-bar');
function reservePurchaseBarSpace(){
  if(!root.isConnected)return;
  const height=Math.ceil(purchaseBar.getBoundingClientRect().height);
  if(height>0)document.documentElement.style.setProperty('--purchase-bar-height',`${height}px`);
}
reservePurchaseBarSpace();
if('ResizeObserver' in window){
  const purchaseBarObserver=new ResizeObserver(reservePurchaseBarSpace);
  purchaseBarObserver.observe(purchaseBar);
  cleanup.push(()=>purchaseBarObserver.disconnect());
}else{
  on(window,'resize',reservePurchaseBarSpace);
}
document.fonts?.ready.then(reservePurchaseBarSpace);



function setupScrollMotion() {
  if (!('IntersectionObserver' in window) || typeof Element.prototype.animate !== 'function' || !window.matchMedia) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (preference.matches) return;

  const compact = window.matchMedia('(max-width: 600px)').matches;
  const targets = new Map();
  const pending = new Set();
  const running = new Map();
  let observer;
  let stopped = false;

  function add(selector, { photo = false, stagger = false } = {}) {
    let rowTop = null;
    let column = 0;
    document.querySelectorAll(selector).forEach(element => {
      
      if (element.matches('a, button, input, select, textarea, summary, [tabindex]') || element.querySelector('a, button, input, select, textarea, summary, [tabindex]')) return;
      const bounds = element.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      if (rowTop === null || Math.abs(bounds.top - rowTop) > 20) {
        rowTop = bounds.top;
        column = 0;
      } else {
        column += 1;
      }
      targets.set(element, {
        distance: compact ? (photo ? 18 : 12) : (photo ? 26 : 18),
        duration: photo ? 850 : 700,
        delay: stagger ? Math.min(column, 2) * 90 : 0
      });
    });
  }

  function finish(element) {
    pending.delete(element);
    observer?.unobserve(element);
    element.removeAttribute('data-scroll-pending');
    const animation = running.get(element);
    if (animation) {
      running.delete(element);
      animation.cancel();
    }
  }

  function showWithin(container) {
    if (!container || stopped) return;
    for (const element of targets.keys()) {
      if (element === container || container.contains(element) || element.contains(container)) finish(element);
    }
  }

  function stop() {
    if (stopped) return;
    stopped = true;
    observer?.disconnect();
    for (const element of targets.keys()) finish(element);
  }

  function reveal(element) {
    if (stopped || !pending.has(element)) return;
    finish(element);
    if (preference.matches) return;
    const { distance, duration, delay } = targets.get(element);
    try {
      const animation = element.animate([
        { opacity: 0, transform: `translate3d(0, ${distance}px, 0)` },
        { opacity: 1, transform: 'translate3d(0, 0, 0)' }
      ], { duration, delay, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'backwards' });
      running.set(element, animation);
      animation.onfinish = () => finish(element);
    } catch {
      
      finish(element);
    }
  }

  function showHash(hash) {
    if (!hash || hash === '#') return;
    try { showWithin(document.getElementById(decodeURIComponent(hash.slice(1)))); } catch {}
  }

  try {
    add('.story-heading');
    add('.about-visual', { photo: true });
    add('.about-lead, .about-intro, .about-point', { stagger: true });
    add('.science-image, .product-image', { photo: true });
    add('.science-copy, .product-card-body, .expert-perspective');
    add('.expert-profile', { photo: true, stagger: true });
    add('.press-item', { photo: true, stagger: true });
    add('.tv-testimonial-heading, .tv-voice-copy, .tv-main-photo', { photo: true });
    add('.ritual-grid > article', { stagger: true });
    add('.closing .eyebrow, .closing h2');

    const barHeight = document.getElementById('mobile-purchase-bar')?.getBoundingClientRect().height || 0;
    const bottomInset = Math.min(Math.ceil(barHeight) + 24, Math.floor(window.innerHeight / 3));
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) reveal(entry.target);
    }, { threshold: 0.04, rootMargin: `0px 0px -${bottomInset}px 0px` });

    for (const [element, config] of targets) {
      
      if (element.getBoundingClientRect().top < window.innerHeight - bottomInset) continue;
      observer.observe(element);
      element.style.setProperty('--scroll-rise', `${config.distance}px`);
      element.setAttribute('data-scroll-reveal', '');
      element.setAttribute('data-scroll-pending', '');
      pending.add(element);
    }

    showHash(window.location.hash);
    on(window,'hashchange', () => showHash(window.location.hash));
    on(document,'click', event => {
      const link = event.target.closest?.('a[href^="#"]');
      if (link) showHash(link.getAttribute('href'));
    });
    on(document,'focusin', event => showWithin(event.target.closest('section') || event.target));
    on(window,'beforeprint', stop, { once: true });
    on(window,'pagehide', stop, { once: true });
    cleanup.push(stop);
    const onPreferenceChange = () => { if (preference.matches) stop(); };
    if (preference.addEventListener) preference.addEventListener('change', onPreferenceChange);
    else preference.addListener(onPreferenceChange);
  } catch {
    
    stop();
  }
}

setupScrollMotion();

}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeUmbilicalLP,{once:true});else initializeUmbilicalLP();
document.addEventListener('shopify:section:load',event=>{if(event.target.querySelector('#umbilical-lp-root'))initializeUmbilicalLP();});
document.addEventListener('shopify:section:unload',event=>{if(event.target.querySelector('#umbilical-lp-root'))window.__umbilicalLPCleanup?.();});
})();

  } catch(e) { console.error(e); }
})();
})();
